import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {AutoVisitForm, FormValues} from "~/apps/packages/auto-visits/components/AutoVisitForm/AutoVisitForm";
import {useCreateAutoVisit, useCurrentCarrierId} from "~/apps/packages/auto-visits/hooks";
import React, {useEffect} from "react";
import {useHistory} from "react-router-dom";
import omit from "lodash/omit";
import {Box, Container} from "@mui/material";
import {AutoVisitCreateResult} from "~/apps/packages/auto-visits/components/AutoVisitCreateResult";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {BrandAppBar} from "~/apps/core/ui/BrandAppBar";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useUserAuthenticated} from "~/auth/hooks";
import moment from "moment";


export const CreatePage = () => {
    const handleError = useErrorHandler();
    const history = useHistory();
    const userAuthenticated = useUserAuthenticated();
    const [create, {data: createResult, error: saveError}] = useCreateAutoVisit();
    const [carrierId] = useCurrentCarrierId();
    const loading = !carrierId;

    useEffect(() => {
        if (saveError) {
            handleError(saveError);
        }
    }, [saveError]);

    const handleSubmit = (data: FormValues) => {
        return create({
            ...omit(data, "ServiceList", "CargoList", "Vehicle", "TimeSlot", "Carrier", "Driver", "CheckPoint", "Date"),
            Date: moment(data.Date).format("YYYY-MM-DD"),
            TimeSlotID: data?.TimeSlot?.ID,
            VehicleID: data?.Vehicle?.ID,
            CarrierID: carrierId,
            DriverID: data?.Driver?.ID,
            CheckPointID: data?.CheckPoint?.ID,
            Services: data?.ServiceList?.map(item => ({
                ID: item.ServiceID,
                CargoID: item.CargoID,
                Quantity: 1,
            })),
            Cargos: data?.CargoList?.map(item => ({
                ID: item.CargoID,
                StorageID: item.StorageID,
                Quantity: item.Quantity,
                Description: "",
                Address: {}
            }))
        });
    }

    const handleContinueClick = () => {
        history.goBack();
    }

    const handleBrandClick = () => {
        history.push("/");
    }

    if (createResult) {
        return (
            <>
                <BrandAppBar onBrandClick={handleBrandClick}/>
                <Box marginTop="72px"/>
                <Container>
                    <AutoVisitCreateResult autoVisit={createResult} onContinue={handleContinueClick}/>
                </Container>
            </>
        )
    }

    return (
        <TitleLayout title="Новый автовизит" disableGutters>
            <LoadingResult loading={loading}/>
            {!loading && (
                <AutoVisitForm
                    key={String(userAuthenticated)} // reset form after login
                    carrierId={carrierId}
                    onSubmit={handleSubmit}
                    variant="create"
                />
            )}

        </TitleLayout>
    )
}